// Танхим захиалга (сурагч) — 3 алхам: Өдөр → Танхим → Цаг, дараа нь хүн/зорилго.
// Гар утсанд зориулж чип/карт хэлбэртэй; захиалагдсан цаг идэвхгүй харагдана.
import React, { useEffect, useMemo, useState } from "react";
import { Button, DatePicker, Input, InputNumber, Modal, Select, Tag, message, Spin, Empty } from "antd";
import { FiChevronLeft, FiClock, FiUsers, FiMapPin, FiCheck, FiLock, FiUserCheck } from "react-icons/fi";
import dayjs from "dayjs";
import { instance } from "utils/axios";

const STATUS = {
  pending: { color: "gold", label: "Хүлээгдэж буй" },
  approved: { color: "green", label: "Зөвшөөрсөн" },
  rejected: { color: "red", label: "Татгалзсан" },
  cancelled: { color: "default", label: "Цуцалсан" },
};
const toMin = (t) => { const [h, m] = String(t).split(":").map(Number); return h * 60 + (m || 0); };
const fromMin = (n) => `${String(Math.floor(n / 60)).padStart(2, "0")}:${String(n % 60).padStart(2, "0")}`;
const DOW = ["Ня", "Да", "Мя", "Лх", "Пү", "Ба", "Бя"];

export default function RoomBooking() {
  const [date, setDate] = useState(dayjs());
  const [grid, setGrid] = useState(null);
  const [mine, setMine] = useState([]);
  const [loading, setLoading] = useState(false);
  const [room, setRoom] = useState(null);
  const [start, setStart] = useState(null); // slot string
  const [dur, setDur] = useState(60); // минут
  const [form, setForm] = useState({ headCount: 2, purpose: "" });
  const [submitting, setSubmitting] = useState(false);
  const [showMine, setShowMine] = useState(false);
  // 21:00-аас хойш дуусах захиалгад зөвшөөрөх багш (сонголт)
  const [approvers, setApprovers] = useState([]);
  const [approverUserId, setApproverUserId] = useState(null);

  const dateStr = date.format("YYYY-MM-DD");

  const load = () => {
    setLoading(true);
    Promise.all([
      instance({ method: "get", url: "/student/booking/grid", params: { date: dateStr } }).then((r) => setGrid(r.data)),
      instance({ method: "get", url: "/student/booking/my" }).then((r) => setMine(r.data || [])),
    ])
      .catch(() => {})
      .then(() => setLoading(false));
  };
  useEffect(() => { setRoom(null); setStart(null); load(); }, [dateStr]); // eslint-disable-line react-hooks/exhaustive-deps

  const slots = grid?.slots || [];
  const slotMin = grid?.window?.slotMinutes || 30;
  const maxMin = grid?.maxMinutes || 180;
  const isPast = (slot) =>
    grid && (dateStr < grid.now.date || (dateStr === grid.now.date && toMin(slot) + slotMin <= grid.now.minutes));
  const busyAt = (roomId, slot) =>
    (grid?.bookings || []).some((b) => b.facilityId === roomId && toMin(b.startTime) <= toMin(slot) && toMin(slot) < toMin(b.endTime));
  const freeSlots = (roomId) => slots.filter((s) => !isPast(s) && !busyAt(roomId, s));

  // Сонгосон эхлэлээс хэдэн минут дараалан сул байна
  const maxDurFrom = (roomId, s) => {
    if (!s) return 0;
    let i = slots.indexOf(s), n = 0;
    while (i < slots.length && !isPast(slots[i]) && !busyAt(roomId, slots[i]) && n < maxMin) { n += slotMin; i++; }
    return n;
  };
  const durOptions = useMemo(() => {
    const max = room && start ? maxDurFrom(room.id, start) : 0;
    const out = [];
    for (let m = slotMin; m <= maxMin; m += slotMin) out.push({ value: m, ok: m <= max });
    return out;
  }, [room, start, slots, grid]); // eslint-disable-line react-hooks/exhaustive-deps
  useEffect(() => {
    // Сонголт хүчингүй болбол хамгийн ойрын боломжит уртад буулгана
    const ok = durOptions.filter((d) => d.ok).map((d) => d.value);
    if (ok.length && !ok.includes(dur)) setDur(ok[ok.length - 1] >= 60 ? 60 : ok[ok.length - 1]);
  }, [durOptions]); // eslint-disable-line react-hooks/exhaustive-deps

  const endTime = start ? fromMin(toMin(start) + dur) : null;
  // Сурагчийн өөрөө захиалж болох хязгаар (ж: 21:00) — түүнээс хойш багш сонгоно
  const studentEnd = grid?.studentEnd || "21:00";
  const needsTeacher = !!endTime && !room?.approver && toMin(endTime) > toMin(studentEnd);
  useEffect(() => {
    if (needsTeacher && !approvers.length)
      instance({ method: "get", url: "/student/booking/approvers" }).then((r) => setApprovers(r.data || [])).catch(() => {});
  }, [needsTeacher]); // eslint-disable-line react-hooks/exhaustive-deps
  const fmtDur = (m) => (m % 60 ? `${Math.floor(m / 60) ? Math.floor(m / 60) + "ц " : ""}${m % 60}мин` : `${m / 60} цаг`);

  const submit = () => {
    if (!room || !start) return;
    if (!String(form.purpose || "").trim()) return message.warning("Ямар зорилгоор ашиглахаа бичнэ үү");
    if (needsTeacher && !approverUserId) return message.warning(`${studentEnd}-аас хойших захиалгад зөвшөөрөх багшаа сонгоно уу`);
    setSubmitting(true);
    instance({
      method: "post", url: "/student/booking",
      data: { facilityId: room.id, bookingDate: dateStr, startTime: start, endTime, headCount: form.headCount, purpose: form.purpose, approverUserId: needsTeacher ? approverUserId : undefined },
    })
      .then(() => {
        message.success("Хүсэлт илгээгдлээ — зөвшөөрөгдөхөд баталгаажна");
        setRoom(null); setStart(null); setForm({ headCount: 2, purpose: "" }); setApproverUserId(null);
        load();
      })
      .catch((e) => message.error(e?.response?.data?.error || "Илгээж чадсангүй"))
      .finally(() => setSubmitting(false));
  };

  const cancel = (id) =>
    Modal.confirm({
      title: "Захиалгаа цуцлах уу?", okText: "Цуцлах", okButtonProps: { danger: true }, cancelText: "Болих",
      onOk: () => instance({ method: "delete", url: `/student/booking/${id}` })
        .then(() => { message.success("Цуцлагдлаа"); load(); })
        .catch((e) => message.error(e?.response?.data?.error || "Цуцалж чадсангүй")),
    });

  // Өдрийн чипүүд — өнөөдрөөс 7 хоног
  const dayChips = Array.from({ length: 7 }, (_, i) => dayjs().add(i, "day"));
  const active = mine.filter((b) => ["pending", "approved"].includes(b.status) && b.bookingDate >= dayjs().format("YYYY-MM-DD"));

  return (
    <div className="pt-4 md:pt-6 flex flex-col gap-4">
      <div className="flex items-end justify-between">
        <div>
          <h1 className="ptitle">Танхим захиалга</h1>
          <p className="psub">Хичээлийн дараа сул ангийг захиалж ашиглана{grid ? ` · ${grid.window.start}–${grid.window.end}` : ""}</p>
        </div>
        <button onClick={() => setShowMine((v) => !v)} className="text-sm text-primary font-medium">
          Миний захиалга {active.length ? <span className="ml-1 bg-primary text-white rounded-full px-2 py-0.5 text-xs">{active.length}</span> : null}
        </button>
      </div>

      {/* Миний захиалгууд (нээж хаана) */}
      {showMine && (
        <section className="pcard pcard-pad">
          <h2 className="font-bold mb-2">Миний захиалгууд</h2>
          {mine.length ? (
            <div className="flex flex-col divide-y divide-gray-50">
              {mine.slice(0, 10).map((b) => (
                <div key={b.id} className="py-2.5 flex items-center gap-3 flex-wrap">
                  <div className="font-semibold text-sm w-28">{b.facility?.name}</div>
                  <div className="text-sm text-gray-600">{b.bookingDate} · {b.startTime}–{b.endTime} · {b.headCount} хүн</div>
                  <Tag color={STATUS[b.status]?.color} className="!mr-0">{STATUS[b.status]?.label}</Tag>
                  {b.approver && b.status === "pending" && <span className="text-xs text-purple-700 w-full">Зөвшөөрөгч: {b.approver.name}</span>}
                  {b.adminNote && <span className="text-xs text-red-500 w-full">{b.adminNote}</span>}
                  {["pending", "approved"].includes(b.status) && (
                    <Button size="small" danger className="ml-auto" onClick={() => cancel(b.id)}>Цуцлах</Button>
                  )}
                </div>
              ))}
            </div>
          ) : <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description="Захиалга байхгүй" />}
        </section>
      )}

      {/* Сурагчийн тал түр хаалттай */}
      {grid && grid.studentEnabled === false && (
        <section className="pcard pcard-pad text-center py-8">
          <span className="inline-flex h-12 w-12 rounded-2xl bg-amber-50 text-amber-600 items-center justify-center mb-3"><FiLock size={22} /></span>
          <h2 className="font-bold text-base">Танхим захиалга түр хаалттай</h2>
          <p className="text-sm text-gray-500 mt-1">Танхимуудын тохиргоо хийгдэж байна. Удахгүй нээгдэнэ.</p>
        </section>
      )}

      {/* 1. Өдөр */}
      {(!grid || grid.studentEnabled !== false) && (<>
      <section className="pcard pcard-pad">
        <div className="flex items-center gap-2 mb-3">
          <span className="h-6 w-6 rounded-full bg-primary text-white text-xs font-bold flex items-center justify-center">1</span>
          <h2 className="font-bold">Өдөр</h2>
          <DatePicker size="small" className="ml-auto" value={date} onChange={(d) => d && setDate(d)} allowClear={false} format="YYYY-MM-DD"
            disabledDate={(d) => d && d < dayjs().startOf("day")} />
        </div>
        <div className="hscroll">
          {dayChips.map((d) => {
            const on = d.isSame(date, "day");
            return (
              <button key={d.format("YYYY-MM-DD")} onClick={() => setDate(d)}
                className={`shrink-0 w-[64px] rounded-2xl border py-2 flex flex-col items-center ${on ? "bg-primary text-white border-primary" : "bg-white border-gray-200 text-gray-700"}`}>
                <span className="text-[11px] opacity-70">{d.isSame(dayjs(), "day") ? "Өнөөдөр" : DOW[d.day()]}</span>
                <span className="text-lg font-bold leading-tight">{d.format("DD")}</span>
                <span className="text-[10px] opacity-70">{d.format("MM")}-р сар</span>
              </button>
            );
          })}
        </div>
      </section>

      {/* 2. Танхим */}
      <section className="pcard pcard-pad">
        <div className="flex items-center gap-2 mb-3">
          <span className="h-6 w-6 rounded-full bg-primary text-white text-xs font-bold flex items-center justify-center">2</span>
          <h2 className="font-bold">Танхим</h2>
          {room && <button onClick={() => { setRoom(null); setStart(null); }} className="ml-auto text-xs text-primary flex items-center gap-1"><FiChevronLeft /> өөр танхим</button>}
        </div>
        {loading && !grid ? (
          <div className="flex justify-center py-6"><Spin /></div>
        ) : room ? (
          <div className="flex items-center gap-3 rounded-xl border border-primary bg-primary/5 p-3">
            <span className="h-10 w-10 rounded-xl bg-primary text-white flex items-center justify-center"><FiMapPin /></span>
            <div>
              <div className="font-bold">{room.name} <span className="text-gray-400 font-normal text-xs">{room.floor}</span></div>
              <div className="text-xs text-gray-500">{room.capacity ? `${room.capacity} хүн · ` : ""}{room.description}</div>
            </div>
            <FiCheck className="ml-auto text-primary" />
          </div>
        ) : (
          <div className="grid grid-cols-2 md:grid-cols-4 gap-2">
            {(grid?.rooms || []).map((r) => {
              const free = freeSlots(r.id).length;
              const none = free === 0;
              return (
                <button key={r.id} disabled={none} onClick={() => { setRoom(r); setStart(null); }}
                  className={`text-left rounded-2xl border p-3 transition-colors ${none ? "bg-gray-50 border-gray-100 text-gray-300" : "bg-white border-gray-200 hover:border-primary"}`}>
                  <div className="font-bold text-sm truncate">{r.name}</div>
                  <div className="text-[11px] opacity-70 truncate">{r.floor} · {r.capacity ? `${r.capacity} хүн` : r.description}</div>
                  <div className={`mt-2 text-[11px] font-medium ${none ? "" : "text-emerald-600"}`}>
                    {none ? "Сул цаг алга" : `${(free * slotMin) / 60} цаг сул`}
                  </div>
                </button>
              );
            })}
          </div>
        )}
      </section>

      {/* 3. Цаг */}
      {room && (
        <section className="pcard pcard-pad">
          <div className="flex items-center gap-2 mb-3">
            <span className="h-6 w-6 rounded-full bg-primary text-white text-xs font-bold flex items-center justify-center">3</span>
            <h2 className="font-bold">Цаг</h2>
          </div>
          <div className="text-xs text-gray-500 mb-1.5 flex items-center gap-1"><FiClock /> Эхлэх цаг</div>
          <div className="flex flex-wrap gap-2 mb-3">
            {slots.map((s) => {
              const dis = isPast(s) || busyAt(room.id, s);
              const on = s === start;
              return (
                <button key={s} disabled={dis} onClick={() => setStart(s)}
                  className={`pchip ${on ? "pchip-on" : dis ? "pchip-dis line-through" : "pchip-off"}`}>{s}</button>
              );
            })}
          </div>
          {start && (
            <>
              <div className="text-xs text-gray-500 mb-1.5">Үргэлжлэх хугацаа</div>
              <div className="flex flex-wrap gap-2">
                {durOptions.map((d) => (
                  <button key={d.value} disabled={!d.ok} onClick={() => setDur(d.value)}
                    className={`pchip ${dur === d.value ? "pchip-on" : d.ok ? "pchip-off" : "pchip-dis"}`}>{fmtDur(d.value)}</button>
                ))}
              </div>
              <div className="mt-3 text-sm font-semibold text-gray-800">{start} – {endTime} · {fmtDur(dur)}</div>
            </>
          )}
        </section>
      )}

      {/* 4. Хүн + зорилго → илгээх */}
      {room && start && (
        <section className="pcard pcard-pad">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-3">
            <div>
              <div className="text-xs text-gray-500 mb-1 flex items-center gap-1"><FiUsers /> Хэдэн хүүхэд</div>
              <InputNumber min={1} max={room.capacity || 50} value={form.headCount} onChange={(v) => setForm((f) => ({ ...f, headCount: v }))} className="w-full" />
            </div>
            <div className="md:col-span-2">
              <div className="text-xs text-gray-500 mb-1">Ямар зорилгоор</div>
              <Input.TextArea rows={2} value={form.purpose} onChange={(e) => setForm((f) => ({ ...f, purpose: e.target.value }))} placeholder="ж: Математикийн олимпиадын бэлтгэл" />
            </div>
          </div>
          <div className="mt-3 rounded-xl bg-gray-50 p-3 text-sm flex items-center gap-2 flex-wrap">
            <b>{room.name}</b> · {date.format("MM.DD")} ({DOW[date.day()]}) · <b>{start}–{endTime}</b> · {form.headCount} хүн
          </div>
          {/* Зөвшөөрөгч: танхимын тусгай зөвшөөрөгч, эсвэл 21:00-аас хойш сурагчийн сонгох багш */}
          {room.approver ? (
            <div className="mt-3 rounded-xl bg-purple-50 text-purple-800 p-3 text-sm flex items-center gap-2">
              <FiUserCheck /> Энэ танхимыг <b>{room.approver.name}</b> багш зөвшөөрнө
            </div>
          ) : needsTeacher ? (
            <div className="mt-3">
              <div className="text-xs text-gray-500 mb-1 flex items-center gap-1"><FiUserCheck /> {studentEnd}-аас хойш — зөвшөөрөх багшаа сонгоно уу</div>
              <Select
                className="w-full" size="large" showSearch optionFilterProp="label" placeholder="Багш сонгох"
                value={approverUserId} onChange={setApproverUserId}
                options={approvers.map((a) => ({ value: a.id, label: `${a.name}${a.position ? ` · ${a.position}` : ""}` }))}
              />
            </div>
          ) : null}
          <Button type="primary" size="large" block className="mt-3" loading={submitting} onClick={submit}>
            Хүсэлт илгээх
          </Button>
          <div className="text-[11px] text-gray-400 text-center mt-2">Зөвшөөрөгдсөний дараа танхим танд баталгаажна</div>
        </section>
      )}
      </>)}
    </div>
  );
}
